module.exports = __webpack_public_path__ + "img/sidebar-logo.3d8e9a1a.svg";